import { COLOR } from '@src/styles/color';
import styled from 'styled-components';

export const VoiceInfoContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;

  .avatar-badge-icon {
    width: 16px;
    height: 16px;
  }

  .voice-info-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;

    .voice-name-container {
      display: flex;
      align-items: center;
      gap: 8px;

      .voice-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .trending-label {
    border: 1px solid ${COLOR.functionalPink[16]};
    background-color: ${COLOR.functionalPink[4]};
    padding: 4px;
    border-radius: 16px;
    min-width: ${({ isVietnamese }) => (isVietnamese ? '72px' : '85px')};
    gap: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .credit-factor-label {
    border: 1px solid ${COLOR.bluev2[16]};
    background-color: ${COLOR.bluev2[4]};
    padding: 4px 8px;
    border-radius: 16px;
    gap: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
`;

export const VoiceDescriptionContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;

  .dot-container {
    padding: 2px;
  }
`;
